import React from "react";

type Props = {
  title: string;
  content: string;
  onClose: () => void;
};

export const TextModal = ({ title, content, onClose }: Props) => {
  return (
    <div className="fixed inset-0 z-50 bg-black/70 flex items-center justify-center px-4">
      <div className="bg-[#0f1f1c] text-white rounded-lg max-w-lg w-full p-6 relative">
        <h2 className="text-2xl font-bold mb-4">{title}</h2>
        <div className="text-sm leading-relaxed max-h-[60vh] overflow-y-auto whitespace-pre-line">
          {content}
        </div>
        <button
          onClick={onClose}
          className="absolute top-2 right-3 text-white text-xl"
        >
          ×
        </button>
      </div>
    </div>
  );
};
